export enum TextboxStatus {
    Warning = 'warning',
    Error = 'error'
}
